module.exports = __webpack_public_path__ + "img/aParty_110523_A.3da37712.jpg";